import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ScrollTopBtn.css';

export default function ScrollTopBtn() {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);
  const [launching, setLaunching] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    if (launching) return;
    setLaunching(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => setLaunching(false), 900);
  };

  return (
    <button
      className={`stb${visible ? ' stb--visible' : ''}${launching ? ' stb--launch' : ''}`}
      onClick={handleClick}
      aria-label={t('a11y.back_to_top')}
    >
      {/* Trail particles */}
      <span className="stb-trail stb-trail-1" />
      <span className="stb-trail stb-trail-2" />
      <span className="stb-trail stb-trail-3" />

      {/* Icon */}
      <span className="stb-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
          <path d="M12 19V5" />
          <path d="M5 12l7-7 7 7" />
        </svg>
      </span>

      {/* Ripple on hover */}
      <span className="stb-ring" />
    </button>
  );
}
